import { StyleSheet, Font } from '@react-pdf/renderer';   
// Font.register({
//     family: 'NunitoRegular',
//     src: '/fonts/Nunito-Regular.ttf'
// });

// Font.register({
//     family: 'NunitoBold',
//     src: '/fonts/Nunito-Bold.ttf'
// });
const styles = StyleSheet.create({
    page: {
        padding: 5,
    },
    section: {
        margin: 5,
        padding: 10,
        flexGrow: 1,
    },
    table: {
        display: 'table',
        width: '100%',
        borderStyle: 'solid',
        borderColor: '#808080',
        borderWidth: 1,
        borderCollapse: 'collapse',
    },
    tableRow: {
        flexDirection: 'row',
    },
    tableCell: {
        flex: 1,
        borderWidth: 1,
        borderColor: '#808080',
        padding: 5,
        backgroundColor: '#fff',
       // fontFamily: 'NunitoRegular',
        fontSize: 10,
    },
    tableHeaderRow: {
        flexDirection: 'row',
        backgroundColor: '#808080',
    },
    tableHeaderCell: {
        flex: 1,
        borderWidth: 1,
        borderColor: '#808080',
        padding: 5,
        color: '#ffffff',
        //fontFamily: 'NunitoBold',
        fontSize: 10,
        textAlign:"center"
    },
    srNoCell: {
        flex: 0.3,
        borderWidth: 1,
        borderColor: '#808080',
        padding: 5,
        textAlign: 'center',
        backgroundColor: '#fff',
       // fontFamily: 'NunitoRegular',
        fontSize: 10,
    },
    srNoHeaderCell: {
        flex: 0.3,
        borderWidth: 1,
        borderColor: '#808080',
        padding: 5,
        color: '#ffffff',
       // fontFamily: 'NunitoBold',
        fontSize: 10,
    },
    hr_divider: {
        width: '100%',
        height: 1,
        backgroundColor: '#000',
        marginVertical: 5,
    },
    footer: {
        fontSize: 10,
        textAlign: 'left',
        fontFamily: 'NunitoRegular',
        position: 'absolute',
        bottom: 0,
    },
    image: { width: 100, height: 100, margin: 5 },
});

export default styles;